import { Injectable } from '@angular/core';
import {
  LastSuccessfulSynchronization,
  LastSuccessfulSynchronizationItem,
} from 'src/app/shared/local-db/models/last-successful-synchronization';
import { LastSuccessfulSynchronizationRepository } from 'src/app/shared/local-db/repositories/last-successful-synchronization.repository';

@Injectable({
  providedIn: 'root',
})
export class SynchronizationSummaryService {
  constructor(
    private readonly lastSuccessfulSynchronizationRepository: LastSuccessfulSynchronizationRepository
  ) {}

  async getLastSynchronizationSummary(
    userEmail: string
  ): Promise<LastSuccessfulSynchronization | undefined> {
    return await this.lastSuccessfulSynchronizationRepository.getLatest(userEmail);
  }

  async saveSynchronizationSummary(
    userEmail: string,
    items: LastSuccessfulSynchronizationItem[]
  ): Promise<void> {
    const summary = new LastSuccessfulSynchronization({
      userEmail,
      executedAt: new Date(),
      items,
    });

    await this.lastSuccessfulSynchronizationRepository.saveLatest(summary);
  }

  async mergeSynchronizationSummary(
    userEmail: string,
    items: LastSuccessfulSynchronizationItem[]
  ): Promise<void> {
    const currentSummary =
      await this.lastSuccessfulSynchronizationRepository.getLatest(userEmail);
    const currentItems = currentSummary?.items ?? [];
    const mergedItems = [...currentItems];

    for (const item of items) {
      const existingItemIndex = mergedItems.findIndex(
        currentItem => currentItem.labelKey === item.labelKey
      );

      if (existingItemIndex >= 0) {
        mergedItems[existingItemIndex] = item;
        continue;
      }

      mergedItems.push(item);
    }

    const summary = new LastSuccessfulSynchronization({
      userEmail,
      executedAt: currentSummary?.executedAt ?? new Date(),
      items: mergedItems,
    });

    await this.lastSuccessfulSynchronizationRepository.saveLatest(summary);
  }
}
